import React from "react";
import { Backdrop } from "@mui/material";
import SquarehubLoader from "./SquarehubLoader";

const BackdropScreen = ({ open }) => {
  return (
    <Backdrop
      open={open}
      sx={(theme) => ({
        zIndex: theme.zIndex.modal,
        backgroundColor: "rgba(255, 255, 255, 0.7)",
      })}
    >
      <SquarehubLoader size={72} />
    </Backdrop>
  );
};

export default BackdropScreen;
